import { Controller } from "@hotwired/stimulus"
import { acceptAnalytics, initGoogleAnalytics, rejectAnalytics } from "../google_analytics/tracker"

export default class extends Controller {
  static targets = ["banner"]
  static values = {
    measurementId: String,
    scriptSrc: String,
    consent: String,
    consentCookie: String
  }

  connect() {
    initGoogleAnalytics({
      measurementId: this.measurementIdValue,
      scriptSrc: this.scriptSrcValue,
      consentCookie: this.consentCookieValue,
      consent: this.consentValue
    })
  }

  accept(event) {
    event.preventDefault()
    acceptAnalytics()
    this.#hideBanner()
  }

  reject(event) {
    event.preventDefault()
    rejectAnalytics()
    this.#hideBanner()
  }

  #hideBanner() {
    if (this.hasBannerTarget) this.bannerTarget.hidden = true
  }
}
